import React, { useEffect, useState } from "react";
import { Menu, Share2 } from "lucide-react";
import AuthButton from "./AuthButton";

export default function Header({
  navigate,
  showAbout,
  user,
  onLogin,
  onAccount,
  showBlog = true,
  onShareSite,
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // CRA exposes only variables prefixed with REACT_APP_
  const BLOG_BASE_URL = process.env.REACT_APP_BLOG_URL || '/blog';

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const media = window.matchMedia("(min-width: 768px)");
    const handler = (event) => {
      if (event.matches) {
        setMobileMenuOpen(false);
      }
    };
    media.addEventListener("change", handler);
    return () => media.removeEventListener("change", handler);
  }, []);

  const closeMobileMenu = () => setMobileMenuOpen(false);

  const handleNavigate = (route) => {
    navigate(route);
    closeMobileMenu();
  };

  return (
    <div className="sticky sticky-safe-top z-50 bg-white md:static md:z-auto">
      <header className="flex items-center justify-between px-5 md:px-6 h-14 border-b bg-white">
        <div className="flex items-center gap-3">
          <button
            type="button"
            className="md:hidden inline-flex h-10 w-10 items-center justify-center rounded-md text-slate-600 hover:bg-slate-100"
            onClick={() => setMobileMenuOpen((prev) => !prev)}
            aria-label="Открыть меню"
            aria-expanded={mobileMenuOpen}
          >
            <Menu className="h-5 w-5" />
          </button>
          <div
            className="flex items-center gap-2 font-semibold text-slate-900 cursor-pointer"
            onClick={() => handleNavigate("home")}
          >
            <span className="inline-flex h-6 w-6 items-center justify-center rounded-md bg-blue-600 text-white">✓</span>
            СоцПлан
          </div>
        </div>
        <nav className="hidden md:flex items-center gap-6 text-sm text-slate-600">
          {showAbout && (
            <a href="#about" className="hover:text-slate-900">
              О сервисе
            </a>
          )}
          <button onClick={() => handleNavigate("faq")} className="hover:text-slate-900">
            Вопросы
          </button>
          <button onClick={() => handleNavigate("support")} className="hover:text-slate-900">
            Поддержка
          </button>
          <button onClick={() => handleNavigate("tariffs")} className="hover:text-slate-900">Тарифы</button>
          {showBlog && (
            <a href={(BLOG_BASE_URL)} className="hover:text-slate-900">
              Блог
            </a>
          )}
        </nav>
        <div className="flex items-center gap-3">
          {onShareSite && (
            <button
              type="button"
              onClick={onShareSite}
              aria-label="Поделиться сайтом"
              className="hidden md:inline-flex items-center gap-2 rounded-md px-2 py-2 text-sm font-medium text-slate-600 hover:text-slate-900"
            >
              <Share2 className="h-4 w-4" />
              Поделиться
            </button>
          )}
          <AuthButton user={user} onLogin={onLogin} onAccount={onAccount} />
        </div>
      </header>
      {mobileMenuOpen && (
        <nav className="md:hidden border-t border-b border-slate-200 bg-white px-5 py-3 space-y-2 text-sm text-slate-700">
          {showAbout && (
            <a href="#about" onClick={closeMobileMenu} className="block hover:text-slate-900">
              О сервисе
            </a>
          )}
          <button onClick={() => handleNavigate("faq")} className="block w-full text-left hover:text-slate-900">
            Вопросы
          </button>
          <button onClick={() => handleNavigate("support")} className="block w-full text-left hover:text-slate-900">
            Поддержка
          </button>
          <button onClick={() => handleNavigate("tariffs")} className="block w-full text-left hover:text-slate-900">Тарифы</button>
          {showBlog && (
            <a href={(BLOG_BASE_URL)} onClick={closeMobileMenu} className="block hover:text-slate-900">
              Блог
            </a>
          )}
          {onShareSite && (
            <button
              type="button"
              onClick={() => {
                closeMobileMenu();
                onShareSite();
              }}
              className="inline-flex w-full items-center justify-start gap-2 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 hover:text-slate-900"
            >
              <Share2 className="h-4 w-4" />
              Поделиться
            </button>
          )}
        </nav>
      )}
    </div>
  );
}
